var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 17H4V5H12V3H4C2.9 3 2 3.9 2 5V17C2 18.1 2.89 19 4 19H8V20C8 20.55 8.45 21 9 21H15C15.55 21 16 20.55 16 20V19H20C21.1 19 22 18.1 22 17V14H20V17Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.71 13.29L21.3 9.7C21.69 9.31 21.69 8.68 21.3 8.29C20.91 7.9 20.28 7.9 19.89 8.29L18 10.17V4C18 3.45 17.55 3 17 3C16.45 3 16 3.45 16 4V10.17L14.11 8.29C13.72 7.9 13.09 7.9 12.7 8.29C12.31 8.68 12.31 9.31 12.7 9.7L16.29 13.29C16.69 13.68 17.32 13.68 17.71 13.29Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistration);
export default __webpack_public_path__ + "static/media/registration.e5f6d2847ad4c6db17312bf70ede0539.svg";
export { ForwardRef as ReactComponent };